import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { localStorageService } from './localstorage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IncomingCallService {
  private incomingCallSessionSubject = new BehaviorSubject<any>(null);
  public incomingCall$ = this.incomingCallSessionSubject.asObservable();
  public showPopup = signal(false);
  private http = inject(HttpClient);
  private localStorageService = inject(localStorageService)

  setIncomingCall(session: any) {
    this.incomingCallSessionSubject.next(session);
    this.showPopup.set(true);
  }

  clearIncomingCall() {
    this.incomingCallSessionSubject.next(null);
    this.showPopup.set(false);
  }
  async fetchLeadDetails(phoneNumber: any): Promise<any> {
    try {
      let payload = {
        access_token: this.localStorageService.customGetItem('adminToken'),
        phoneNumber
      };
      let apiUrl = environment.baseUrl;
      let res: any = await this.http
        .post(apiUrl + 'leads/leads_by_number', payload)
        .toPromise();

      if (res.is_error) throw res.err;
      if (res?.data?.[0]) return res.data[0];
      throw new Error('No Data Found');
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

}